import _objectWithoutProperties from "/app/scripts/smweb-scripts/node_modules/@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "/app/scripts/smweb-scripts/node_modules/@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import { createUseStyles } from 'react-jss';
import { defineMessages, T } from '@sm/intl';
import { visuallyHidden } from '@wds/utils';
import { c as classnames } from './vendor-cefadc71.js';
import { sanitizeString } from '@sm/utils';

var calculateQuestionWidthPercentage = function calculateQuestionWidthPercentage(numOfQuestions) {
  var width = 100 / numOfQuestions;

  if (width % 1) {
    return "".concat(width.toFixed(2), "%");
  }

  return "".concat(width, "%");
};

var useStyles$9 = createUseStyles(function (theme) {
  var _ref4;

  return _ref4 = {
    gridRow: {
      maxWidth: '100%',
      marginBottom: '40px'
    },
    gridItem: function gridItem(_ref) {
      var numOfQuestions = _ref.numOfQuestions,
          maxQuestionsPerRow = _ref.maxQuestionsPerRow;
      return _objectSpread({
        marginBottom: '30px'
      }, numOfQuestions > 1 && maxQuestionsPerRow > 1 ? {
        paddingRight: '20px',
        width: calculateQuestionWidthPercentage(Math.min(maxQuestionsPerRow, numOfQuestions))
      } : {
        width: '100%'
      });
    }
  }, _defineProperty(_ref4, "@media (max-width: ".concat(theme.breakpoints.xsMax, ")"), {
    gridItem: {
      paddingRight: "0 !important",
      width: '100% !important'
    }
  }), _defineProperty(_ref4, "@media (min-width: ".concat(theme.breakpoints.smMin, ")"), {
    gridRow: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap'
    }
  }), _defineProperty(_ref4, "@media (min-width: ".concat(theme.breakpoints.smMin, ") and (max-width: ").concat(theme.breakpoints.mdMax, ")"), {
    // TODO: RAWR-735 bug in JSS - always applies the last item,
    // so if the last has maxQuestionsPerRow > 1 all gridItem are 50% wide
    gridItem: function gridItem(_ref2) {
      var maxQuestionsPerRow = _ref2.maxQuestionsPerRow;
      return maxQuestionsPerRow > 1 ? {
        paddingRight: '20px',
        // two columns layout
        width: '50%'
      } : {
        width: '100%'
      };
    }
  }), _defineProperty(_ref4, "@media (min-width: ".concat(theme.breakpoints.lgMin, ")"), {
    gridItem: function gridItem(_ref3) {
      var numOfQuestions = _ref3.numOfQuestions;
      return numOfQuestions > 1 ? {
        paddingRight: '20px'
      } : {};
    }
  }), _ref4;
});

var QuestionRowLayout = function QuestionRowLayout(_ref5) {
  var children = _ref5.children,
      _ref5$maxQuestionsPer = _ref5.maxQuestionsPerRow,
      maxQuestionsPerRow = _ref5$maxQuestionsPer === void 0 ? 4 : _ref5$maxQuestionsPer;
  var numOfQuestions = React.Children.count(children);

  var _useStyles$ = useStyles$9({
    numOfQuestions: numOfQuestions,
    maxQuestionsPerRow: maxQuestionsPerRow
  }),
      gridItem = _useStyles$.gridItem,
      gridRow = _useStyles$.gridRow;

  return React.createElement("div", {
    className: gridRow
  }, React.Children.map(children, function (child) {
    return React.createElement("div", {
      className: gridItem
    }, child);
  }));
};

var createFieldId = function createFieldId(questionId) {
  return "question-field-".concat(questionId);
};

var createLabelId = function createLabelId(questionId) {
  return "question-title-".concat(questionId);
};

var createErrorId = function createErrorId(questionId) {
  return "".concat(questionId, "-validation-message");
};

var useStyles$8 = createUseStyles(function (theme) {
  var _a;

  return {
    button: {
      color: theme.nextButton.color,
      backgroundColor: theme.nextButton.backgroundColor,
      fontFamily: (_a = theme.questionBody.fontFamily) !== null && _a !== void 0 ? _a : {},
      fontSize: 15,
      border: [1, 'solid', 'transparent'],
      borderRadius: 2,
      padding: [1, 6],
      maxWidth: '100%',
      minWidth: 60,
      minHeight: 40,
      cursor: 'pointer',
      overflowWrap: 'break-word'
    }
  };
}); // This might need to be a prop later once confirmed

var MAX_LENGTH = 20;

var Button = function Button(_ref6) {
  var _ref6$text = _ref6.text,
      text = _ref6$text === void 0 ? 'OK' : _ref6$text,
      type = _ref6.type,
      props = _objectWithoutProperties(_ref6, ["text", "type"]);

  var _useStyles$2 = useStyles$8(),
      button = _useStyles$2.button;

  var slicedText = text.length <= MAX_LENGTH ? text : text.slice(0, MAX_LENGTH);
  return (// This is disabled instead of creating a trivial ternary operator
    // eslint-disable-next-line react/button-has-type
    React.createElement("button", Object.assign({}, props, {
      className: button,
      type: type
    }), slicedText)
  );
};

var useStyles$7 = createUseStyles({
  visuallyHidden: visuallyHidden
});

var VisuallyHidden = function VisuallyHidden(_ref7) {
  var children = _ref7.children,
      Element = _ref7.element;

  var _useStyles$3 = useStyles$7(),
      visuallyHidden = _useStyles$3.visuallyHidden;

  return React.createElement(Element, {
    className: visuallyHidden
  }, children);
};

var useStyles$6 = createUseStyles({
  paddingBox: function paddingBox(_ref8) {
    var padding = _ref8.padding;
    return {
      paddingTop: (padding === null || padding === void 0 ? void 0 : padding.top) || 0,
      paddingBottom: (padding === null || padding === void 0 ? void 0 : padding.bottom) || 0,
      paddingLeft: (padding === null || padding === void 0 ? void 0 : padding.left) || 0,
      paddingRight: (padding === null || padding === void 0 ? void 0 : padding.right) || 0
    };
  }
});

var QuestionSpacing = function QuestionSpacing(_ref9) {
  var padding = _ref9.padding,
      children = _ref9.children;

  var _useStyles$4 = useStyles$6({
    padding: padding
  }),
      paddingBox = _useStyles$4.paddingBox;

  return React.createElement("div", {
    className: paddingBox
  }, children);
};

var useStyles$5 = createUseStyles({
  footerRow: function footerRow(_ref10) {
    var hasFooterPadding = _ref10.hasFooterPadding;
    return {
      paddingTop: hasFooterPadding ? 20 : 0
    };
  },
  containerStyles: function containerStyles(_ref11) {
    var clickShield = _ref11.clickShield;
    return {
      position: 'relative',
      opacity: clickShield ? '0.5' : '1',
      transition: 'opacity 500ms ease-out',
      pointerEvents: clickShield ? 'none' : 'auto'
    };
  },
  errorRow: {
    marginBottom: 10
  },
  formReset: {
    border: 0,
    minWidth: 0
  },
  headerRow: {
    marginBottom: 24
  }
});
var COPY = defineMessages({
  QUESTION_TITLE: {
    id: 'ResponseQuestion.QUESTION_TITLE',
    defaultMessage: 'Question Title',
    description: '[Type: Label][Vis: low] - question landmark for screen readers only'
  }
});

var QuestionFieldLayoutTemplate = function QuestionFieldLayoutTemplate(_ref12) {
  var footer = _ref12.footer,
      hasFooterPadding = _ref12.hasFooterPadding,
      children = _ref12.children,
      clickShield = _ref12.clickShield,
      error = _ref12.error,
      id = _ref12.id,
      padding = _ref12.padding,
      title = _ref12.title,
      props = _objectWithoutProperties(_ref12, ["footer", "hasFooterPadding", "children", "clickShield", "error", "id", "padding", "title"]);

  var _useStyles$5 = useStyles$5({
    hasFooterPadding: hasFooterPadding,
    clickShield: clickShield
  }),
      footerRow = _useStyles$5.footerRow,
      containerStyles = _useStyles$5.containerStyles,
      formReset = _useStyles$5.formReset,
      errorRow = _useStyles$5.errorRow,
      headerRow = _useStyles$5.headerRow;

  return React.createElement("div", Object.assign({
    id: id
  }, props, {
    className: containerStyles
  }), React.createElement(VisuallyHidden, {
    element: "h3"
  }, React.createElement(T, {
    desc: COPY.QUESTION_TITLE
  })), React.createElement(QuestionSpacing, {
    padding: padding
  }, React.createElement("fieldset", {
    className: formReset
  }, React.createElement("legend", {
    className: headerRow
  }, error && React.createElement("div", {
    className: errorRow
  }, error), title), children), footer && React.createElement("div", {
    className: footerRow
  }, footer)));
};

createUseStyles(function (theme) {
  var _ref13;

  return _ref13 = {
    containerVertical: {
      display: 'initial'
    },
    containerHorizontal: {
      display: 'block'
    },

    /** shared between horizontal and vertical columns */
    column: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start'
    },
    columnHorizontal: {},

    /** Horizontal Column that adjust width to content width */
    columnHorizontalAutoAdjust: {
      width: 'auto'
    }
  }, _defineProperty(_ref13, "@media (min-width: ".concat(theme.breakpoints.xsMin, ")"), {
    containerVertical: {
      display: 'flex'
    },
    containerHorizontal: {
      display: 'flex',
      flexWrap: 'wrap'
    }
  }), _defineProperty(_ref13, "@media only screen and (min-width: ".concat(theme.breakpoints.lgMin, ")"), {
    columnHorizontal: {
      width: '19%'
    }
  }), _defineProperty(_ref13, "@media (min-width: ".concat(theme.breakpoints.smMin, ") and (max-width: ").concat(theme.breakpoints.mdMax, ")"), {
    columnHorizontal: {
      width: '24%'
    }
  }), _defineProperty(_ref13, "@media only screen and (max-width: ".concat(theme.breakpoints.xxsMax, ")"), {
    columnHorizontal: {
      width: '100%',
      display: 'block'
    },
    columnHorizontalAutoAdjust: {
      width: '100%',
      display: 'block'
    }
  }), _ref13;
});
var textReset = {
  margin: 0
};
var inlineSpacing = {
  marginRight: '0.25em'
};
var useStyles$4 = createUseStyles(function (theme) {
  var _theme$questionTitle = theme.questionTitle,
      fontSize = _theme$questionTitle.fontSize,
      questionTitleFormatting = _objectWithoutProperties(_theme$questionTitle, ["fontSize"]);

  var questionTitleFontSize = theme.isAccessible ? '22px' : fontSize !== null && fontSize !== void 0 ? fontSize : {};
  return {
    addonContainer: {
      display: 'inline-block',
      margin: [0, 5],
      verticalAlign: 'text-bottom'
    },
    container: {
      position: 'relative'
    },
    questionNumber: inlineSpacing,
    questionTitle: function questionTitle(_ref14) {
      var useDefaultFrontSize = _ref14.useDefaultFrontSize;

      var _a;

      return _objectSpread(_objectSpread(_objectSpread({}, textReset), questionTitleFormatting), {}, {
        color: ((_a = theme.questionTitle) === null || _a === void 0 ? void 0 : _a.color) || theme.questionColor,
        fontSize: useDefaultFrontSize && !theme.isAccessible ? theme.fontSize.body : questionTitleFontSize,
        lineHeight: 1.25,
        whiteSpace: 'normal',
        wordWrap: 'break-word'
      });
    },
    requiredAsterisk: _objectSpread(_objectSpread({}, inlineSpacing), {}, {
      display: 'inline-block'
    })
  };
});
/* eslint-disable @typescript-eslint/naming-convention */

var listSpacing = {
  margin: [16, 0],
  padding: [0, 0, 0, 40]
};
var mediaReset = {
  border: 0,
  maxWidth: '100%'
};
var useStyles$3 = createUseStyles({
  richTextContent: {
    // Typography
    '& a': {
      // Links are not themed by default. Users must select a link color in the editor
      color: 'blue',
      textDecoration: 'underline',
      '&:hover': {
        cursor: 'pointer'
      },
      '&:focus': {
        outline: 'currentColor auto 1px'
      }
    },
    '& ol': _objectSpread(_objectSpread({}, listSpacing), {}, {
      listStyleType: 'decimal'
    }),
    '& ul': _objectSpread(_objectSpread({}, listSpacing), {}, {
      listStyle: 'disc outside none',
      '& ul li': {
        listStyle: 'circle'
      }
    }),
    '& p': {
      margin: [13, 0]
    },
    '& b': {
      fontWeight: 'bold'
    },
    '& strong': {
      fontWeight: 'bold'
    },
    '& em': {
      fontStyle: 'italic'
    },
    '& i': {
      fontStyle: 'italic'
    },
    '& big': {
      fontSize: 'larger'
    },
    '& small': {
      fontSize: 'smaller'
    },
    '& sup': {
      fontSize: '75%',
      lineHeight: 0,
      position: 'relative',
      top: '-0.5em',
      verticalAlign: 'baseline'
    },
    // Media embeds
    '& iframe': mediaReset,
    '& img': _objectSpread(_objectSpread({}, mediaReset), {}, {
      height: 'auto',
      '-ms-interpolation-mode': 'bicubic'
    })
  }
}); // Support iframe video embeds and their matching attributes

var sanitizeOptions = {
  ADD_TAGS: ['iframe'],
  ADD_ATTR: ['target', 'allow', 'allowfullscreen', 'frameborder', 'sandbox', 'scrolling']
};

var RichText = function RichText(_ref15) {
  var Element = _ref15.element,
      text = _ref15.text;

  var _useStyles$6 = useStyles$3(),
      richTextContent = _useStyles$6.richTextContent;

  return React.createElement(Element, {
    className: richTextContent,
    dangerouslySetInnerHTML: {
      __html: sanitizeString(text, sanitizeOptions)
    }
  });
};

var QuestionTitle = function QuestionTitle(_ref16) {
  var addon = _ref16.addon,
      heading = _ref16.heading,
      id = _ref16.id,
      number = _ref16.number,
      numbered = _ref16.numbered,
      required = _ref16.required,
      _ref16$useDefaultFron = _ref16.useDefaultFrontSize,
      useDefaultFrontSize = _ref16$useDefaultFron === void 0 ? false : _ref16$useDefaultFron,
      props = _objectWithoutProperties(_ref16, ["addon", "heading", "id", "number", "numbered", "required", "useDefaultFrontSize"]);

  var _useStyles$7 = useStyles$4({
    useDefaultFrontSize: useDefaultFrontSize
  }),
      addonContainer = _useStyles$7.addonContainer,
      container = _useStyles$7.container,
      questionNumber = _useStyles$7.questionNumber,
      questionTitle = _useStyles$7.questionTitle,
      requiredAsterisk = _useStyles$7.requiredAsterisk;

  return React.createElement("h4", Object.assign({
    id: id,
    className: classnames(container, questionTitle)
  }, props), required && React.createElement("span", {
    "aria-hidden": true,
    className: requiredAsterisk
  }, "*"), numbered && React.createElement("span", {
    className: questionNumber
  }, number, "."), React.createElement(RichText, {
    element: "span",
    text: heading
  }), addon && React.createElement("span", {
    className: addonContainer
  }, addon));
};

var useStyles$2 = createUseStyles(function (theme) {
  var _a;

  return {
    icon: {
      backgroundClip: 'padding-box',
      backgroundColor: theme.primaryAccentColor,
      borderRadius: 3,
      color: theme.secondaryAccentColor,
      fontSize: theme.fontSize.body,
      padding: [0, 5]
    },
    iconWrapper: {
      marginRight: 5
    },
    validationMessage: {
      fontFamily: (_a = theme.questionBody.fontFamily) !== null && _a !== void 0 ? _a : {},
      lineHeight: 1.5,
      color: theme.questionBody.color,
      fontWeight: theme.fontWeight.light,
      fontSize: theme.fontSize.body
    }
  };
});

var ValidationMessage = function ValidationMessage(_ref17) {
  var children = _ref17.children,
      id = _ref17.id,
      props = _objectWithoutProperties(_ref17, ["children", "id"]);

  var _useStyles$8 = useStyles$2(),
      icon = _useStyles$8.icon,
      iconWrapper = _useStyles$8.iconWrapper,
      validationMessage = _useStyles$8.validationMessage;

  return React.createElement("h4", Object.assign({
    className: validationMessage,
    "aria-live": "polite",
    id: id
  }, props), React.createElement("span", {
    className: iconWrapper
  }, React.createElement("span", {
    "aria-hidden": "true",
    className: icon
  }, "!")), React.createElement("span", null, children));
};

var useStyles$1 = createUseStyles(function (theme) {
  var _a;

  return _defineProperty({
    textareaStyles: _objectSpread(_objectSpread({
      fontFamily: (_a = theme.questionBody.fontFamily) !== null && _a !== void 0 ? _a : {},
      fontSize: '18px',
      lineHeight: '1.15em',
      padding: '6px 60px 6px 6px',
      maxWidth: '100%',
      color: theme.questionBody.color,
      outlineColor: theme.primaryAccentColor,
      transition: 'all 0.1s linear',
      verticalAlign: 'top',
      textSizeAdjust: 'auto'
    }, theme.isAccessible ? {
      fontWeight: 500,
      opacity: 1,
      border: "1px solid ".concat(theme.answerColor),
      backgroundColor: '#fff'
    } : {
      fontWeight: 300,
      backgroundColor: theme.input.bgColor,
      border: '0'
    }), {}, {
      '&:focus': {
        borderColor: theme.input.activeColor,
        borderRadius: '2px'
      },
      '&:focus, &:hover': theme.isAccessible ? {
        // should be there but was broken
        // https://code.corp.surveymonkey.com/devmonkeys/smlib.surveytemplates/blob/main/smlib/surveytemplates/themes_v3/base_css.jinja2#L1094-L1097
        boxShadow: '0px 2px 8px rgba(0, 0, 0, 7)'
      } : {},
      '&:disabled': _objectSpread({
        boxShadow: 'none'
      }, theme.isAccessible ? {} : {
        borderColor: 'transparent',
        opacity: 0.5
      })
    })
  }, "@media only screen and (max-width: ".concat(theme.breakpoints.mdMax, ")"), {
    textareaStyles: {
      fontSize: '16px'
    }
  });
}); // Custom textarea component for Response.

var TextArea = function TextArea(_ref19) {
  var placeholder = _ref19.placeholder,
      disabled = _ref19.disabled,
      rows = _ref19.rows,
      cols = _ref19.cols,
      id = _ref19.id,
      name = _ref19.name,
      defaultValue = _ref19.defaultValue,
      labelId = _ref19.labelId,
      errorId = _ref19.errorId,
      _ref19$required = _ref19.required,
      required = _ref19$required === void 0 ? false : _ref19$required,
      onChange = _ref19.onChange,
      onBlur = _ref19.onBlur,
      onFocus = _ref19.onFocus;

  var _useStyles$9 = useStyles$1(),
      textareaStyles = _useStyles$9.textareaStyles;

  return React.createElement("textarea", {
    className: textareaStyles,
    placeholder: placeholder,
    disabled: disabled,
    rows: rows,
    cols: cols,
    id: id,
    name: name,
    defaultValue: defaultValue,
    "aria-labelledby": labelId,
    "aria-describedby": errorId,
    "aria-required": required,
    onChange: onChange,
    onBlur: onBlur,
    onFocus: onFocus,
    spellCheck: true
  });
};

var useStyles = createUseStyles(function (theme) {
  var _a;

  return _defineProperty({
    inputStyles: _objectSpread(_objectSpread({
      fontFamily: (_a = theme.questionBody.fontFamily) !== null && _a !== void 0 ? _a : {},
      fontSize: '18px',
      lineHeight: '1.5em',
      height: function height(_ref20) {
        var autoHeight = _ref20.autoHeight;
        return autoHeight ? {} : '50px';
      },
      padding: '6px',
      maxWidth: '100%',
      color: theme.questionBody.color,
      transition: 'all 0.1s linear'
    }, theme.isAccessible ? {
      fontWeight: 500,
      opacity: 1,
      border: theme.isAccessible ? "1px solid ".concat(theme.answerColor) : '0',
      backgroundColor: '#fff'
    } : {
      fontWeight: 300,
      backgroundColor: theme.input.bgColor,
      border: '0'
    }), {}, {
      '&:focus': {
        outline: 'none',
        borderColor: theme.input.activeColor,
        borderRadius: '2px'
      },
      '&:focus, &:hover': _objectSpread({}, theme.isAccessible ? {
        // should be there but was broken
        // https://code.corp.surveymonkey.com/devmonkeys/smlib.surveytemplates/blob/main/smlib/surveytemplates/themes_v3/base_css.jinja2#L1094-L1097
        boxShadow: '0px 2px 8px rgba(0, 0, 0, 7)'
      } : {}),
      '&:disabled': _objectSpread({
        boxShadow: 'none'
      }, theme.isAccessible ? {} : {
        borderColor: 'transparent',
        opacity: 0.5
      })
    })
  }, "@media only screen and (max-width: ".concat(theme.breakpoints.mdMax, ")"), {
    inputStyles: {
      fontSize: '16px'
    }
  });
});

var TextInput = function TextInput(_ref22) {
  var defaultValue = _ref22.defaultValue,
      disabled = _ref22.disabled,
      errorId = _ref22.errorId,
      id = _ref22.id,
      labelId = _ref22.labelId,
      name = _ref22.name,
      onBlur = _ref22.onBlur,
      onChange = _ref22.onChange,
      onFocus = _ref22.onFocus,
      placeholder = _ref22.placeholder,
      _ref22$required = _ref22.required,
      required = _ref22$required === void 0 ? false : _ref22$required,
      _ref22$autoHeight = _ref22.autoHeight,
      autoHeight = _ref22$autoHeight === void 0 ? false : _ref22$autoHeight,
      _ref22$size = _ref22.size,
      size = _ref22$size === void 0 ? 50 : _ref22$size;

  var _useStyles = useStyles({
    autoHeight: autoHeight
  }),
      inputStyles = _useStyles.inputStyles;

  return React.createElement("input", {
    type: "text",
    className: inputStyles,
    placeholder: placeholder,
    disabled: disabled,
    size: size,
    id: id,
    name: name,
    defaultValue: defaultValue,
    onChange: onChange,
    "aria-labelledby": labelId,
    onBlur: onBlur,
    onFocus: onFocus,
    "aria-describedby": errorId,
    "aria-required": required
  });
};

var QuestionField = function QuestionField(_ref23) {
  var active = _ref23.active,
      disabled = _ref23.disabled,
      error = _ref23.error,
      title = _ref23.title,
      onSubmit = _ref23.onSubmit,
      onUpdate = _ref23.onUpdate,
      _ref23$padding = _ref23.padding,
      padding = _ref23$padding === void 0 ? {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0
  } : _ref23$padding,
      questionId = _ref23.questionId,
      questionNumber = _ref23.questionNumber,
      required = _ref23.required,
      _ref23$survey = _ref23.survey,
      asteriskEnabled = _ref23$survey.asteriskEnabled,
      numberingEnabled = _ref23$survey.numberingEnabled,
      defaultValue = _ref23.value,
      variant = _ref23.variant;
  var titleId = createLabelId(questionId);
  var errorId = createErrorId(questionId);
  var fieldId = createFieldId(questionId);
  var isAutoScroll = variant === 'auto-scroll';
  var showClickShield = isAutoScroll && !active; // Requires more conditional logic on integration with RAWR-109 form manager

  var showButton = isAutoScroll && active;
  return React.createElement("div", null, React.createElement(QuestionFieldLayoutTemplate, {
    footer: showButton && React.createElement(Button, {
      text: "OK",
      type: "submit",
      onClick: onSubmit
    }),
    hasFooterPadding: true,
    clickShield: showClickShield,
    error: error && React.createElement(ValidationMessage, {
      id: errorId
    }, error),
    id: fieldId,
    padding: padding,
    title: React.createElement(QuestionTitle, {
      heading: title,
      id: titleId,
      number: questionNumber,
      numbered: numberingEnabled,
      required: asteriskEnabled && required
    })
  }, React.createElement(TextInput, {
    defaultValue: defaultValue,
    disabled: disabled,
    errorId: error && errorId,
    id: questionId,
    labelId: titleId,
    name: questionId,
    required: required,
    onChange: function onChange(event) {
      return onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate(event.target.value);
    }
  })));
};

var CommentBox = function CommentBox(_ref24) {
  var active = _ref24.active,
      _ref24$cols = _ref24.cols,
      cols = _ref24$cols === void 0 ? 50 : _ref24$cols,
      disabled = _ref24.disabled,
      error = _ref24.error,
      title = _ref24.title,
      onSubmit = _ref24.onSubmit,
      onUpdate = _ref24.onUpdate,
      _ref24$padding = _ref24.padding,
      padding = _ref24$padding === void 0 ? {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0
  } : _ref24$padding,
      questionId = _ref24.questionId,
      questionNumber = _ref24.questionNumber,
      required = _ref24.required,
      _ref24$rows = _ref24.rows,
      rows = _ref24$rows === void 0 ? 3 : _ref24$rows,
      _ref24$survey = _ref24.survey,
      asteriskEnabled = _ref24$survey.asteriskEnabled,
      numberingEnabled = _ref24$survey.numberingEnabled,
      defaultValue = _ref24.value,
      variant = _ref24.variant;
  var titleId = createLabelId(questionId);
  var errorId = createErrorId(questionId);
  var fieldId = createFieldId(questionId);
  var isAutoScroll = variant === 'auto-scroll';
  var showClickShield = isAutoScroll && !active; // // Requires more conditional logic on integration with RAWR-109 form manager

  var showButton = isAutoScroll && active;
  return React.createElement(QuestionFieldLayoutTemplate, {
    footer: showButton && React.createElement(Button, {
      text: "OK",
      type: "submit",
      onClick: onSubmit
    }),
    hasFooterPadding: true,
    clickShield: showClickShield,
    error: error && React.createElement(ValidationMessage, {
      id: errorId
    }, error),
    id: fieldId,
    padding: padding,
    title: React.createElement(QuestionTitle, {
      heading: title,
      id: titleId,
      number: questionNumber,
      numbered: numberingEnabled,
      required: asteriskEnabled && required
    })
  }, React.createElement(TextArea, {
    cols: cols,
    defaultValue: defaultValue,
    disabled: disabled,
    errorId: error && errorId,
    id: questionId,
    labelId: titleId,
    name: questionId,
    required: required,
    rows: rows,
    onChange: function onChange(event) {
      return onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate(event.target.value);
    }
  }));
};

export { CommentBox, QuestionRowLayout, QuestionField as SingleTextbox };